import api from "../../components/services/api";
import { useParams } from "react-router";
import { useState } from "react";
import { useEffect } from "react";
import moment from "moment";
import "./SaleOrder.css";
export default function SaleOrder() {
  let { id } = useParams();
  const [data, setData] = useState();
  const getData = async () => {
    const res = await api(`api/saleorder/detail/${id}`);
    const data = await res.data;
    setData(data);
  };
  useEffect(() => {
    getData();
  }, []);


  const pageCount = Math.ceil(data?.detail?.length / 6)
  const rows = [];
  for (let pageIndex = 0; pageIndex < pageCount; pageIndex++) {
    rows.push(<>
    <page>
        <div class="header">
          <img src="/images/logo2.png" class="logo" />
          <div className="header_title">
            <h3>SRITRANG LOGISTIC COMPANY LIMITED</h3>
            <h5>บริษัท ศรีตรังโลจิสติกส์ จำกัด </h5>
          </div>
        </div>
        <div class="titleR">
          <h3>ใบสั่งขาย / Sale Order </h3>
        </div>
        <div class="content">
          <div className="rowR">
            <p className="header_p">Quotation No. </p>
            <p> {data?.QuotationNo}</p>
          </div>
          <div className="rowR">
            <p className="header_p">Sale Order No. </p>
            <p> {data?.SaleOrderNo}</p>
          </div>
          <div className="rowR">
            <p className="header_p">Customer Code </p>
            <p> {data?.CustomerCode}</p>
          </div>
          <div className="rowR">
            <p className="header_p">Date </p>
            <p> {moment(data?.Date).format("DD/MM/yyyy")}</p>
          </div>
          <div className="rowR">
            <p className="header_p">Customer Name </p>
            <p> {data?.CustomerName}</p>
          </div>
          <div className="rowR">
            <p className="header_p">Custom Gate </p>
            <p> {data?.CustomGate}</p>
          </div>
          <div className="rowR">
            <p className="header_p">Shipper Ref No. </p>
            <p> {data?.ShipperRefNo}</p>
          </div>
          <div className="rowR">
            <p className="header_p">Transportation </p>
            <p>{data?.Transportation}</p>
          </div>
          <div className="rowR">
            <p className="header_p">Booking No. </p>
            <p>{data?.BookingNo} </p>
          </div>
          <div className="rowR">
            <p className="header_p">Tug </p>
            <p>{data?.Tug} </p>
          </div>
          <div class="rowR sub">
            <p className="header_p">Quantity </p>
            <p>{data?.Quantity} </p>
          </div>
          <div class="rowR sub">
            <p className="header_p">Size </p>
            <p> {data?.Size}</p>
          </div>
          <div class="rowR">
            <p className="header_p">Barge </p>
            <p> {data?.Barge}</p>
          </div>
          <div class="rowR"></div>
          <div class="rowR">
            <p className="header_p">Voyage </p>
            <p> {data?.Yoyage}</p>
          </div>
        </div>
        <div class="content_center">
          <div class="rowR first">
            <p className="header_p">Service Route </p>
            <p></p>
          </div>
          <div class="rowR">
            <p className="header_p">Port of Loading</p>
            <p>{data?.PortofLoadingTo}</p>
          </div>
          <div class="rowR">
            <p className="header_p">ETD</p>
            <p>
              {" "}
              {moment(data?.ETD).format("DD/MM/yyyy")} {data?.ETDTime}
            </p>
          </div>
          <div class="rowR first"></div>
          <div class="rowR">
            <p className="header_p">Port of Discharge</p>
            <p>{data?.PortofDischarge}</p>
          </div>
          <div class="rowR">
            <p className="header_p">ETA</p>
            <p>
              {moment(data?.ETA).format("DD/MM/yyyy")} {data?.ETATime}
            </p>
          </div>
        </div>
        <div class="containerR">
           
          <table border="1" cellpadding="10" cellspacing="0">
            <tr style={{ border: "1px solid" }}>
              <th style={{ border: "1px solid" }}>Code</th>
              <th style={{ border: "1px solid" }}>Service Description</th>
              <th style={{ border: "1px solid" }}>Size</th>
              <th style={{ border: "1px solid" }}>Unit Price</th>
              <th style={{ border: "1px solid" }}>Quantity</th>
              <th style={{ border: "1px solid" }}>Tax</th>
              <th style={{ border: "1px solid" }}>Total</th>
              <th style={{ border: "1px solid" }}>Currency</th>
            </tr>
            
              <tr
                style={{
                  border: "1px solid",
                  fontSize: "16px",
                  height: "27px",
                }}
              >
                <td style={{ border: "1px solid" }}>{data?.detail?.slice(pageIndex * 6, pageIndex * 6 + 6)[0]?.Code}</td>
                <td style={{ border: "1px solid" }}>{data?.detail?.slice(pageIndex * 6, pageIndex * 6 + 6)[0]?.ServiceDescription}</td>
                <td style={{ border: "1px solid" }}>{data?.detail?.slice(pageIndex * 6, pageIndex * 6 + 6)[0]?.Size}</td>
                <td style={{ border: "1px solid" }}>{data?.detail?.slice(pageIndex * 6, pageIndex * 6 + 6)[0]?.UnitPrice?.toLocaleString(undefined, {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })}</td>
                <td style={{ border: "1px solid" }}>{data?.detail?.slice(pageIndex * 6, pageIndex * 6 + 6)[0]?.Quantity}</td>
                <td style={{ border: "1px solid" }}>{data?.detail?.slice(pageIndex * 6, pageIndex * 6 + 6)[0]?.Tax}</td>
                <td style={{ border: "1px solid" }}>{data?.detail?.slice(pageIndex * 6, pageIndex * 6 + 6)[0]?.Total?.toLocaleString(undefined, {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })}</td>
                <td style={{ border: "1px solid" }}>{data?.detail?.slice(pageIndex * 6, pageIndex * 6 + 6)[0]?.Currency}</td>
              </tr>
         
            <tr
              style={{ border: "1px solid", fontSize: "16px", height: "27px" }}
            >
              <td style={{ border: "1px solid" }}>{data?.detail?.slice(pageIndex * 6, pageIndex * 6 + 6)[1]?.Code}</td>
              <td style={{ border: "1px solid" }}>{data?.detail?.slice(pageIndex * 6, pageIndex * 6 + 6)[1]?.ServiceDescription}</td>
              <td style={{ border: "1px solid" }}>{data?.detail?.slice(pageIndex * 6, pageIndex * 6 + 6)[1]?.Size}</td>
              <td style={{ border: "1px solid" }}>{data?.detail?.slice(pageIndex * 6, pageIndex * 6 + 6)[1]?.UnitPrice?.toLocaleString(undefined, {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })}</td>
              <td style={{ border: "1px solid" }}>{data?.detail?.slice(pageIndex * 6, pageIndex * 6 + 6)[1]?.Quantity}</td>
              <td style={{ border: "1px solid" }}>{data?.detail?.slice(pageIndex * 6, pageIndex * 6 + 6)[1]?.Tax}</td>
              <td style={{ border: "1px solid" }}>{data?.detail?.slice(pageIndex * 6, pageIndex * 6 + 6)[1]?.Total?.toLocaleString(undefined, {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })}</td>
              <td style={{ border: "1px solid" }}>{data?.detail?.slice(pageIndex * 6, pageIndex * 6 + 6)[1]?.Currency}</td>
            </tr>
            <tr
              style={{ border: "1px solid", fontSize: "16x", height: "27px" }}
            >
          <td style={{ border: "1px solid" }}>{data?.detail?.slice(pageIndex * 6, pageIndex * 6 + 6)[2]?.Code}</td>
              <td style={{ border: "1px solid" }}>{data?.detail?.slice(pageIndex * 6, pageIndex * 6 + 6)[2]?.ServiceDescription}</td>
              <td style={{ border: "1px solid" }}>{data?.detail?.slice(pageIndex * 6, pageIndex * 6 + 6)[2]?.Size}</td>
              <td style={{ border: "1px solid" }}>{data?.detail?.slice(pageIndex * 6, pageIndex * 6 + 6)[2]?.UnitPrice?.toLocaleString(undefined, {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })}</td>
              <td style={{ border: "1px solid" }}>{data?.detail?.slice(pageIndex * 6, pageIndex * 6 + 6)[2]?.Quantity}</td>
              <td style={{ border: "1px solid" }}>{data?.detail?.slice(pageIndex * 6, pageIndex * 6 + 6)[2]?.Tax}</td>
              <td style={{ border: "1px solid" }}>{data?.detail?.slice(pageIndex * 6, pageIndex * 6 + 6)[2]?.Total?.toLocaleString(undefined, {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })}</td>
              <td style={{ border: "1px solid" }}>{data?.detail?.slice(pageIndex * 6, pageIndex * 6 + 6)[2]?.Currency}</td>
            </tr>
            <tr
              style={{ border: "1px solid", fontSize: "16px", height: "27px" }}
            >
             <td style={{ border: "1px solid" }}>{data?.detail?.slice(pageIndex * 6, pageIndex * 6 + 6)[3]?.Code}</td>
              <td style={{ border: "1px solid" }}>{data?.detail?.slice(pageIndex * 6, pageIndex * 6 + 6)[3]?.ServiceDescription}</td>
              <td style={{ border: "1px solid" }}>{data?.detail?.slice(pageIndex * 6, pageIndex * 6 + 6)[3]?.Size}</td>
              <td style={{ border: "1px solid" }}>{data?.detail?.slice(pageIndex * 6, pageIndex * 6 + 6)[3]?.UnitPrice?.toLocaleString(undefined, {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })}</td>
              <td style={{ border: "1px solid" }}>{data?.detail?.slice(pageIndex * 6, pageIndex * 6 + 6)[3]?.Quantity}</td>
              <td style={{ border: "1px solid" }}>{data?.detail?.slice(pageIndex * 6, pageIndex * 6 + 6)[3]?.Tax}</td>
              <td style={{ border: "1px solid" }}>{data?.detail?.slice(pageIndex * 6, pageIndex * 6 + 6)[3]?.Total?.toLocaleString(undefined, {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })}</td>
              <td style={{ border: "1px solid" }}>{data?.detail?.slice(pageIndex * 6, pageIndex * 6 + 6)[3]?.Currency}</td>
            </tr>
            <tr
              style={{ border: "1px solid", fontSize: "16px", height: "27px" }}
            >
               <td style={{ border: "1px solid" }}>{data?.detail?.slice(pageIndex * 6, pageIndex * 6 + 6)[4]?.Code}</td>
              <td style={{ border: "1px solid" }}>{data?.detail?.slice(pageIndex * 6, pageIndex * 6 + 6)[4]?.ServiceDescription}</td>
              <td style={{ border: "1px solid" }}>{data?.detail?.slice(pageIndex * 6, pageIndex * 6 + 6)[4]?.Size}</td>
              <td style={{ border: "1px solid" }}>{data?.detail?.slice(pageIndex * 6, pageIndex * 6 + 6)[4]?.UnitPrice?.toLocaleString(undefined, {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })}</td>
              <td style={{ border: "1px solid" }}>{data?.detail?.slice(pageIndex * 6, pageIndex * 6 + 6)[4]?.Quantity}</td>
              <td style={{ border: "1px solid" }}>{data?.detail?.slice(pageIndex * 6, pageIndex * 6 + 6)[4]?.Tax}</td>
              <td style={{ border: "1px solid" }}>{data?.detail?.slice(pageIndex * 6, pageIndex * 6 + 6)[4]?.Total?.toLocaleString(undefined, {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })}</td>
              <td style={{ border: "1px solid" }}>{data?.detail?.slice(pageIndex * 6, pageIndex * 6 + 6)[4]?.Currency}</td>
            </tr>
            <tr
              style={{ border: "1px solid", fontSize: "16px", height: "27px" }}
            >
             <td style={{ border: "1px solid" }}>{data?.detail?.slice(pageIndex * 6, pageIndex * 6 + 6)[5]?.Code}</td>
              <td style={{ border: "1px solid" }}>{data?.detail?.slice(pageIndex * 6, pageIndex * 6 + 6)[5]?.ServiceDescription}</td>
              <td style={{ border: "1px solid" }}>{data?.detail?.slice(pageIndex * 6, pageIndex * 6 + 6)[5]?.Size}</td>
              <td style={{ border: "1px solid" }}>{data?.detail?.slice(pageIndex * 6, pageIndex * 6 + 6)[5]?.UnitPrice?.toLocaleString(undefined, {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })}</td>
              <td style={{ border: "1px solid" }}>{data?.detail?.slice(pageIndex * 6, pageIndex * 6 + 6)[5]?.Quantity}</td>
              <td style={{ border: "1px solid" }}>{data?.detail?.slice(pageIndex * 6, pageIndex * 6 + 6)[5]?.Tax}</td>
              <td style={{ border: "1px solid" }}>{data?.detail?.slice(pageIndex * 6, pageIndex * 6 + 6)[5]?.Total?.toLocaleString(undefined, {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })}</td>
              <td style={{ border: "1px solid" }}>{data?.detail?.slice(pageIndex * 6, pageIndex * 6 + 6)[5]?.Currency}</td>
            </tr>
            <tr
              style={{ border: "1px solid", fontSize: "16px", height: "27px" }}
            >
              <td
                style={{ border: "1px solid" }}
                valign="top"
                rowspan="3"
                colspan="3"
              >
                {`Remark:  ${data?.Remark}`}
              </td>
              <td style={{ border: "1px solid" }} colspan="2" align="center">
                Total
              </td>
              <td style={{ border: "1px solid" }} colspan="2">{data?.TotalNoTax?.toLocaleString(undefined, {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })}</td>
              <td style={{ border: "1px solid" }} colspan="2">{data?.detail[0].Currency}</td>
            </tr>
            <tr
              style={{ border: "1px solid", fontSize: "16px", height: "27px" }}
            >
              <td style={{ border: "1px solid" }} colspan="2" align="center">
                Tax
              </td>
              <td style={{ border: "1px solid" }} colspan="2">{data?.TotalTax?.toLocaleString(undefined, {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })}</td>
              <td style={{ border: "1px solid" }}>{data?.detail[0].Currency}</td>
            </tr>
            <tr
              style={{ border: "1px solid", fontSize: "16px", height: "27px" }}
            >
              <td style={{ border: "1px solid" }} colspan="2" align="center">
                Total Amount
              </td>
              <td style={{ border: "1px solid" }} colspan="2">{data?.TotalAmount?.toLocaleString(undefined, {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })}</td>
              <td style={{ border: "1px solid" }}>{data?.detail[0].Currency}</td>
            </tr>
          </table>
        </div>

        <div class="content">
          <div class="rowR full">
            <p className="header_p">Booking Information</p>
            <p> </p>
          </div>
          <div class="rowR full">
            <p className="header_p">Shipping Line</p>
            <p>{data?.ShippingLine} </p>
          </div>
          <div class="rowR">
            <p className="header_p">Port of Loading</p>
            <p>{data?.PortofLoadingTo} </p>
          </div>
          <div class="rowR">
            <p className="header_p">ETD</p>
            <p>{moment(data?.ETDTo).format('DD/MM/yyyy')} {data?.ETDTimeTo} </p>
          </div>
          <div class="rowR">
            <p className="header_p">Port of Discharge</p>
            <p>{data?.PortofDischargeTo} </p>
          </div>
          <div class="rowR">
            <p className="header_p">ETA</p>
            <p> {moment(data?.ETATo).format('DD/MM/yyyy') } {data?.ETATimeTo}</p>
          </div>
          <div class="rowR">
            <p className="header_p">Vessle</p>
            <p> {data?.Vessle}</p>
          </div>
        </div>
        <div class="content_footer_S">
          <div className="rowR">
            <p style={{ lineHeight: "24px" }}>______________________________</p>
            <p>(.........................................................)</p>
            <p>Admin</p>
            <p>Date.............../.............../...............</p>
          </div>
          <div className="rowR">
            <p style={{ lineHeight: "24px" }}>______________________________</p>
            <p>(.........................................................)</p>
            <p>Manager</p>
            <p>Date.............../.............../...............</p>
          </div>
        </div>
        <div class="footer_S">
          <p>SRITRANG LOGISTIC COMPANY LIMITED</p>
          <p> F-MK-005 ฉบับแก้ไขครั้งที่ ..... วันที่อนุมัติใช้ ........./........../.......... </p>
        </div>
      </page>
    </>
    )
  }
  return (
    
          <>
            {rows}
        </> 
    
  );
}
